export const printableTransactionTypes = Object.freeze({
  CREDIT_CARD: 'Credit Card',
  ACH: 'ACH',
  WIRE: 'Wire',
  CHEQUE: 'Cheque',
  CREDIT_WITHOUT_PAYMENT: 'Credit without payment',
});

export const printableUnitStatuses = Object.freeze({
  MOVING_OUT: 'MOVING OUT',
  MOVEOUT_RESERVED: 'MOVEOUT RES',
  OVERDUE_MOVEOUT: 'ODUE MOVEOUT',
  PRE_LIEN: 'PRE LIEN',
});



// WEBPACK FOOTER //
// ./src/utils/enums.js